import Typography from "@portal/components/atoms/v2/typography";
import { MainBox } from "../components/mainBox";
import { IPageProps } from "@portal/types/robot/IPageProps";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { useRobot } from "@portal/app/context/robotProvider";
import { RobotFooterComponent, RobotNavigateToPage } from "../components/footer";
import { TextLine } from "@portal/components/atoms/v2/textLine";
import { SustainabilityInfo } from "./steps/sustainability";
import { IRiskLevel } from "@portal/types/robot/IRiskLevel";
import Link from "next/link";
import Illustration from "@portal/components/atoms/illustrations";
import { useRouter } from "next/navigation";
import { useSession } from "@portal/auth/client/SessionProvider";

export const SustainabilityPage = ({ pageIndex, centerId, isDefaultLanguage }: IPageProps) => {
  const { riskLevelRequest: request } = useRobot();
  const isButtonEnabled = IsValidRequest(request);
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const router = useRouter();
  const { session } = useSession();
  const isLoggedIn = session?.status === "authenticated";

  return (
    <>
      <MainBox>
        <Typography variant="Body">{texts.PAGE_7_INFO_HEADER}</Typography>
        <div className="flex h-52.5 justify-center mt-2">
          <Illustration name="sustainabilityIcon" size="image" />
        </div>
        <Typography variant="H6">{texts.PAGE_7_SUBHEADER}</Typography>
        <TextLine />
        <SustainabilityInfo isDefaultLanguage={isDefaultLanguage} />
        <div className="flex my-2">
          <Link prefetch={false} href="https://norne.no/baerekraft/" target="_blank" className="flex underline items-start">
            <Typography variant="Bold">{texts.PAGE_7_LINK_TEXT}</Typography>
          </Link>
        </div>
      </MainBox>
      <RobotFooterComponent
        pageIndex={pageIndex}
        centerId={centerId}
        primaryButtonText={texts.BUTTON_NEXT}
        primaryButtonClickOverride={() => {
          const newPageIndex = request.sustainability ? pageIndex + 1 : pageIndex + 2;
          const newUrl = RobotNavigateToPage(isLoggedIn ?? false, newPageIndex, centerId);
          router.push(newUrl);
        }}
        secondaryButtonText={texts.BUTTON_BACK}
        disabled={!isButtonEnabled}
      />
    </>
  );
};

function IsValidRequest(request: IRiskLevel) {
  return request.sustainability !== null;
}
